import { ComputedReserveData } from '../hooks/app-data-provider/useAppDataProvider';
import BigNumber from 'bignumber.js';
import { calculateCompoundedRate, SECONDS_PER_YEAR } from '@yldr/math-utils';

export const getBorrowApy = (token: ComputedReserveData): BigNumber => {
  return BigNumber(
    calculateCompoundedRate({ rate: token.variableBorrowRate, duration: SECONDS_PER_YEAR }).toString()
  ).div(BigNumber(10).pow(27));
}
